import { render, staticRenderFns } from "./InputStyledText.vue?vue&type=template&id=11bc9f45&"
import script from "./InputStyledText.vue?vue&type=script&lang=ts&"
export * from "./InputStyledText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports